query IsNumberVerified($phoneNumber: String!) {
    isNumberVerified(phoneNumber: $phoneNumber)
}
